export const ADD_FILE = "add-file";
export const ANDROID = "android";
export const APP_LARGE_THUMBS = "app-large-thumbs";
export const APP_MATERIAL = "app-material";
export const APP_MEDIUM_THUMBS = "app-medium-thumbs";
export const APP_PILEHEIGHT = "app-pileheight";
export const APP_SMALL_THUMBS = "app-small-thumbs";
export const APP_STORE = "app-store";
export const APPLE = "apple";
export const ASCENDING = "ascending";
export const AT_THE_RATE = "at-the-rate";
export const ATTACHMENT = "attachment";
export const AUGMENTED_RUG = "augmented-rug";
export const AUTO_BRIGHTNESS = "auto-brightness";
export const AVATAR = "avatar";
export const BAR_LEFT = "bar-left";
export const BAR_RIGHT = "bar-right";
export const BROKEN_HEART = "broken-heart";
export const BRUSH = "brush";
export const CART = "cart";
export const CARVING = "carving";
export const CHECKED_CIRCLE = "checked-circle";
export const CHECKED_SQUARE = "checked-square";
export const CHECKED = "checked";
export const CHEVRON_DOWN = "chevron-down";
export const CHEVRON_LEFT_CIRCLE = "chevron-left-circle";
export const CHEVRON_LEFT = "chevron-left";
export const CHEVRON_RIGHT = "chevron-right";
export const CHEVRON_UP = "chevron-up";
export const CLEAR_CACHE = "clear-cache";
export const CLOSE_CIRCLE = "close-circle";
export const CLOSE = "close";
export const COLLAPSE = "collapse";
export const COLOR_PALETTE = "color-palette";
export const CONTEXT_MENU_HORIZONTAL = "context-menu-horizontal";
export const CONTEXT_MENU_VERTICAL = "context-menu-vertical";
export const COPY = "copy";
export const COPYRIGHT = "copyright";
export const CREDIT_CARD = "credit-card";
export const CROWN = "crown";
export const DECREASE_HEIGHT = "decrease-height";
export const DELETE = "delete";
export const DESCENDING = "descending";
export const DISABLED = "disabled";
export const DISLIKE = "dislike";
export const DOLLAR = "dollar";
export const DOUBLE_CHEVRON_CAMERA = "double-chevron-camera";
export const DOUBLE_CHEVRON_DOWN = "double-chevron-down";
export const DOUBLE_CHEVRON_LEFT = "double-chevron-left";
export const DOUBLE_CHEVRON_RIGHT = "double-chevron-right";
export const DOUBLE_CHEVRON_UP_CIRCLE = "double-chevron-up-circle";
export const DOUBLE_CHEVRON_UP = "double-chevron-up";
export const DOWNLOAD = "download";
export const DRAG_HANDLE = "drag-handle";
export const DROP_PIN = "drop-pin";
export const EDIT = "edit";
export const EMAIL = "email";
export const ENTER_FULLSCREEN = "enter-fullscreen";
export const ERASE_MARK = "erase-mark";
export const EURO = "euro";
export const EXCLAMATION = "exclamation";
export const EXIT_FULLSCREEN = "exit-fullscreen";
export const EXPAND = "expand";
export const EXTERNAL_LINK = "external-link";
export const EYE_DROPPER = "eye-dropper";
export const FILTER = "filter";
export const FLIP_HORIZONTAL = "flip-horizontal";
export const FLIP_VERTICAL = "flip-vertical";
export const FOLDER_CLOSED = "folder-closed";
export const FOLDER_OPEN = "folder-open";
export const FULL_STAR = "full-star";
export const HALF_STAR = "half-star";
export const HAMBURGER_MENU = "hamburger-menu";
export const HEART_FULL_OF_LOVE = "heart-full-of-love";
export const HEART = "heart";
export const HOME = "home";
export const ICON_NAME_1 = "icon-name-1";
export const ICON_NAME = "icon-name";
export const IMAGE = "image";
export const INCREASE_HEIGHT = "increase-height";
export const INFO_CIRCLE = "info-circle";
export const INFORMATION = "information";
export const LABEL = "label";
export const LANDSCAPE = "landscape";
export const LIGHTNING_BOLT = "lightning-bolt";
export const LIKE = "like";
export const LINKED = "linked";
export const LOCKED = "locked";
export const MAGIC_WAND = "magic-wand";
export const MAP_COLORS = "map-colors";
export const MARK_FLOOR = "mark-floor";
export const MARK_FURNITURE = "mark-furniture";
export const MARK_TOOL = "mark-tool";
export const MASTER_CARD = "master-card";
export const MESSAGE = "message";
export const MINUS = "minus";
export const MOON = "moon";
export const MOVE_CAMERA_DOWN = "move-camera-down";
export const MOVE_CAMERA_UP = "move-camera-up";
export const MOVE = "move";
export const MULTISHOT = "multishot";
export const MUSIC = "music";
export const NO_MUSIC = "no-music";
export const NOTIFICATION_OFF = "notification-off";
export const NOTIFICATION_ON = "notification-on";
export const OPTIONS = "options";
export const PASTE = "paste";
export const PAYPAL_MINI = "paypal-mini";
export const PAYPAL = "paypal";
export const PILE_HEIGHT = "pile-height";
export const PLUS_CIRCLE = "plus-circle";
export const PLUS = "plus";
export const PORTRAIT = "portrait";
export const POUND = "pound";
export const PRINT = "print";
export const QR_CODE = "qr-code";
export const QUESTION_CIRCLE = "question-circle";
export const QUESTION = "question";
export const REDO_1 = "redo-1";
export const REDO = "redo";
export const REFRESH = "refresh";
export const RESET_2 = "reset 2";
export const RESET = "reset";
export const ROTATE_45_CW = "rotate-45-cw";
export const ROTATE_CCW = "rotate-ccw";
export const ROTATE_CW = "rotate-cw";
export const RUBIKS = "rubiks";
export const RUPEE = "rupee";
export const SAVE = "save";
export const SEARCH = "search";
export const SETTINGS = "settings";
export const SHARE = "share";
export const SHUFFLE = "shuffle";
export const SKYPE = "skype";
export const SORT_ASCENDING = "sort-ascending";
export const SORT_AUTOMATIC = "sort-automatic";
export const SORT_DESCENDING = "sort-descending";
export const TARGET = "target";
export const TOGGLE_OFF = "toggle-off";
export const TOGGLE_ON = "toggle-on";
export const TOOLS = "tools";
export const TRIANGLE_DOWN = "triangle-down";
export const TRIANGLE_LEFT = "triangle-left";
export const TRIANGLE_RIGHT = "triangle-right";
export const TRIANGLE_TOP = "triangle-top";
export const TWITTER = "twitter";
export const UNCHECKED_CIRCLE = "unchecked-circle";
export const UNCHECKED_SQUARE = "unchecked-square";
export const UNDO_1 = "undo-1";
export const UNDO = "undo";
export const UNLOCKED = "unlocked";
export const UPLOAD = "upload";
export const VIDEO = "video";
export const VIEWING_HEIGHT = "viewing-height";
export const VIRTUAL_PHOTO_STUDIO = "virtual-photo-studio";
export const VISA_CARD = "visa-card";
export const VR_GLASSES = "vr-glasses";
export const WHATSAPP = "whatsapp";
export const WIFI_OFF = "wifi-off";
export const WIFI_ON = "wifi-on";
export const WINDOWS = "windows";
export const YEN = "yen";
export const ZOOM_IN = "zoom-in";
export const ZOOM_OUT = "zoom-out";
export const NEW_FOLDER = "new-folder";
export const COLLAPSE_ALL = "collapse-all";
export const EXPAND_ALL = "expand-all";
export const CUT = "cut";
export const LIST = "list"
export const SORT_A_Z = "sort-a-z";
export const SORT_Z_A = "sort-z-a";